import { EntityScope } from '../../../../shared/utils/enums';
import { FC, ReactElement } from 'react';
import { Modal } from 'react-bootstrap';
import { ExerciseTagDto } from '../../../../shared/dtos/exerciseTag.dto';
import { ExerciseCategoryDto } from '../../../../shared/dtos/exerciseCategory.dto';
import ExerciseTagForm from './ExerciseTagForm';
import i18next from 'i18next';
import AppModal from '../app-modal/AppModal';

type ExerciseTagModalProps = {
  show: boolean;
  entityScope: EntityScope;
  exerciseTag?: ExerciseTagDto;
  categories: ExerciseCategoryDto[];
  onClose: () => void;
  onSave: () => void;
}

const ExerciseTagModal: FC<ExerciseTagModalProps> = ({
  show,
  entityScope,
  exerciseTag,
  categories,
  onClose,
  onSave
}: ExerciseTagModalProps): ReactElement => {

  return (
    <AppModal show={show} onHide={onClose} backdrop="static" keyboard>
      <Modal.Header closeButton>
        <Modal.Title>{i18next.t(exerciseTag ? 'exerciseTagModal.updateTag' : 'exerciseTagModal.createTag')}</Modal.Title>
      </Modal.Header>

      <Modal.Body>
        <ExerciseTagForm
          initialData={exerciseTag}
          entityScope={entityScope}
          categories={categories}
          onClose={onClose}
          onSubmit={() => {
            onSave();
            onClose();
          }}
        />
      </Modal.Body>
    </AppModal>
  );
};

export default ExerciseTagModal;
